import { useQuery } from '@tanstack/react-query'
import { fetchDistrictsWithRegionByNation, type DistrictWithRegion } from '@/services/districts'

export function useDistrictsWithRegionByNation(nationId: string | undefined) {
  const districtsQuery = useQuery({
    queryKey: ['districts', 'nation', nationId, 'withRegion'],
    queryFn: () => fetchDistrictsWithRegionByNation(nationId!),
    enabled: !!nationId,
  })

  return {
    districts: districtsQuery.data,
    isLoading: districtsQuery.isLoading,
    error: districtsQuery.error,
  }
}

export type { DistrictWithRegion }
